/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils, lodash } from '@ba-ui-toolkit/utils';
import TruncatedText from '@ba-ui-toolkit/truncatedtext';
import PropertiesPane from '../PropertiesPane';
import styles from './SectionStyles.scss';

const textSectionClassName = styles.textSectionClassName.replace(/"/g, '');
const { sanitize, getInheritedProps } = propsUtils;
const { omit } = lodash;

export default class TextSection extends Component {
	static propTypes = {
		label: PropTypes.string.isRequired,
		title: PropTypes.string,
		text: PropTypes.string.isRequired,
		labelSize: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
		textAlign: PropTypes.oneOf(['left', 'right', 'center']),

		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		resizable: PropTypes.bool,
		rtl: PropTypes.bool,
		truncateFullCount: PropTypes.bool,
		className: PropTypes.string,
		style: PropTypes.object,
		...omit(TruncatedText.propTypes, 'value'),
		...PropertiesPane.propTypes,
	};
	static defaultProps = {
		truncateFullCount: false,
		className: '',
		style: {},
	};

	render() {
		const {
			label,
			title,
			text,
			disabled,
			readOnly,
			rtl,
			labelSize,
			textAlign,
			className,
			style,
			...others
		} = this.props;
		const classNames = cx(textSectionClassName, rtl);
		const truncatedTextPassthroughProps = getInheritedProps(others, TruncatedText);
		const propertiesPanePassthroughProps = getInheritedProps(others, PropertiesPane);

		return (
			<PropertiesPane
				{...sanitize(others, TextSection)}
				{...propertiesPanePassthroughProps}
				className={`${classNames} ${className}`}
				label={label}
				title={title}
				rtl={rtl}
				labelSize={labelSize}
				disabled={disabled}
				style={style}
			>
				<div
					data-tid="ba-common-text-section__truncated-text"
					className={cx({ disabled: disabled || readOnly })}
				>
					<TruncatedText
						{...truncatedTextPassthroughProps}
						value={text}
						textAlign={textAlign}
					/>
				</div>
			</PropertiesPane>
		);
	}
}
